package org.example.project.service

import androidx.compose.runtime.Composable
import org.example.project.dashboard.LocalScreenRefreshVersion
import org.example.project.utils.All

object YardLiveSync {
    @Composable
    fun version(includeSnap: Boolean = false): Long {
        val snapVersion = if (includeSnap) GlobalManager.jsonDomainVersion("snap") else 0L
        return maxOf(
            LocalScreenRefreshVersion.current,
            GlobalManager.jsonDomainVersion("yard"),
            GlobalManager.jsonDomainVersion("yard-kontrollen"),
            GlobalManager.jsonDomainVersion("yard-we"),
            GlobalManager.jsonDomainVersion("yard-we-auftrag"),
            GlobalManager.jsonDomainVersion("yard-we-lkw"),
            GlobalManager.jsonDomainVersion("yard-wa"),
            GlobalManager.jsonDomainVersion("yard-wa-auftrag"),
            GlobalManager.jsonDomainVersion("yard-wa-lkw"),
            GlobalManager.jsonDomainVersion("yard-wa-standort"),
            GlobalManager.jsonDomainVersion("yard-vorgangslog"),
            GlobalManager.jsonDomainVersion("yard-infra"),
            GlobalManager.jsonDomainVersion("yard-tor"),
            GlobalManager.jsonDomainVersion("yard-parkplatz"),
            snapVersion
        )
    }

    fun markAuftragChanged(saved: All?) {
        saved ?: return
        val art = saved.auftragsart.trim().uppercase()
        val firmenId = saved.firmenId.trim().ifBlank { "firma" }
        val id = saved.id.trim().ifBlank { saved.lfdNr.takeIf { it > 0 }?.toString().orEmpty() }
        val lfdNr = saved.lfdNr.takeIf { it > 0 }?.toString() ?: id.ifBlank { "1" }
        val lieferschein = saved.lieferscheinnummer.trim()

        when {
            art == "WA" && lieferschein.isNotBlank() && id.isNotBlank() -> {
                GlobalManager.markJsonChanged(
                    "lkw_${id}_${lieferschein}.json",
                    "register/$firmenId/wa/$lieferschein/lkw/lkw_${id}_${lieferschein}.json"
                )
                GlobalManager.markJsonChanged(
                    "auftrag_$lieferschein.json",
                    "register/$firmenId/wa/$lieferschein/auftrag_$lieferschein.json"
                )
            }
            art == "WA" && lieferschein.isNotBlank() -> {
                GlobalManager.markJsonChanged(
                    "auftrag_$lieferschein.json",
                    "register/$firmenId/wa/$lieferschein/auftrag_$lieferschein.json"
                )
            }
            id.isNotBlank() -> {
                GlobalManager.markJsonChanged(
                    "lkw_$id.json",
                    "register/$firmenId/we/$lfdNr/lkw_$id.json"
                )
                GlobalManager.markJsonChanged(
                    "auftrag.json",
                    "register/$firmenId/we/$lfdNr/auftrag.json"
                )
            }
            else -> {
                GlobalManager.markJsonChanged(
                    "auftrag.json",
                    "register/$firmenId/we/$lfdNr/auftrag.json"
                )
            }
        }
    }

    fun markWaStandortChanged(kopf: All, standort: All, firmenId: String = "") {
        val company = firmenId.trim().ifBlank { kopf.firmenId.ifBlank { standort.firmenId }.ifBlank { "firma" } }
        val tour = kopf.lieferscheinnummer.ifBlank { standort.lieferscheinnummer }
        val id = standort.id.ifBlank { standort.waStandortId }
        if (tour.isBlank() || id.isBlank()) return
        GlobalManager.markJsonChanged(
            "standort_$id.json",
            "register/$company/wa/$tour/standorte/standort_$id.json"
        )
    }

    fun markWaStandortDeleted(tour: String, id: String, firmenId: String = "") {
        val company = firmenId.trim().ifBlank { "firma" }
        if (tour.isBlank() || id.isBlank()) return
        GlobalManager.markJsonChanged(
            "standort_$id.json",
            "register/$company/wa/$tour/standorte/standort_$id.json"
        )
    }
}
